import { ComponentFactoryResolver, ComponentRef, Directive, ElementRef, HostListener, Injector, Input, Renderer2, TemplateRef, Type, ViewContainerRef } from '@angular/core';
import { AnatomicMapTooltipComponent } from './anatomic-map-tooltip.component';


@Directive({
    selector: '[anatomicMapTooltip]'
})
export class AnatomicMapTooltipDirective {

    @Input('anatomicMapTooltip') content: string | TemplateRef<any> | Type<any>;

    private componentRef: ComponentRef<AnatomicMapTooltipComponent>;

    constructor(private element: ElementRef,
        private renderer: Renderer2,
        private injector: Injector,
        private resolver: ComponentFactoryResolver,
        private vcr: ViewContainerRef) {
    }

    @HostListener('mouseenter',['$event'])
    mouseenter(event: Event) {
        if(!this.content || this.content == ' ') return;
        if (this.componentRef ) return;
        const factory = this.resolver.resolveComponentFactory(AnatomicMapTooltipComponent);
        const injector = Injector.create({
            providers: [{
                provide: 'tooltipConfig',
                useValue: {
                    top: this.element.nativeElement.getBoundingClientRect().top +60,
                    left: this.element.nativeElement.getBoundingClientRect().left,
                }
            }],
            parent: this.injector
        });
        this.componentRef = this.vcr.createComponent(factory, 0, injector, this.generateNgContent());
    }

    generateNgContent() {
        if (typeof this.content === 'string') {
            const element = this.renderer.createText(this.content);
            return [[element]];
        }

        if (this.content instanceof TemplateRef) {
            const viewRefEmbeddedView = this.content.createEmbeddedView({});
            return [viewRefEmbeddedView.rootNodes];
        }

        // Else it's a component
        const factory = this.resolver.resolveComponentFactory(this.content);
        const viewRefComponent = factory.create(this.injector);
        return [[viewRefComponent.location.nativeElement]];
    }

    @HostListener('mouseleave',['$event'])
    mouseout(event:Event) {
        this.destroy();
    }

    destroy() {
        this.componentRef && this.componentRef.destroy();
        this.componentRef = null;
    }

    ngOnDestroy() {
        this.destroy();
    }
}
